module.exports = __webpack_public_path__ + "img/undraw_compose_music_ovo2.3c011e76.svg";